module.exports = __webpack_public_path__ + "static/img/invite.04de53b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/profileDashboard/vendor/users/invite.jpeg
// module id = ESbL
// module chunks = 0